<template>
  <div class='content-editable'>
    <div v-show='editable' class='tag' :style='fontStyle'>
      <component class='content-editable--input' ref='input' :contenteditable='editable' @input='onInput' :is="tag">
        <span v-html='tmp'></span>
      </component>
      <component v-show='isEmpty' class='placeholder' :is="tag">
        {{ placeholder }}
      </component>
    </div>
    <div v-show='!editable' :style='fontStyle'>
      <component class='content-editable--input' v-html='translatedContent' ref='input-preview' :is="tag">
      </component>
    </div>
  </div>
</template>
<script>
  import _ from 'lodash'
  export default {
    props: {
      html: {type: Boolean, default: false},
      tag: {default: 'h1', type: String},
      value: {default: '', type: String},
      fontScale: {default: 100, type: [Number, String]},
      placeholder: {default: '', type: String},
      editable: {default: true, type: Boolean},
      translated: {default: null, type: String}
    },
    data () {
      return {
        content: null,
        tmp: ''
      }
    },
    methods: {
      onInput () {
        if (this.html) {
          this.content = this.$refs.input.innerHTML
        } else {
          this.content = this.$refs.input.innerText
        }
        this.$emit('input', this.content)
      },
      reload () {
        this.content = this.value
        this.tmp = this.value
      }
    },
    computed: {
      translatedContent () {
        if (this.translated) {
          return this.translated
        } else {
          return this.value
        }
      },
      isEmpty() {
        if (!this.editable){
          return false
        }
        return this.value === null || this.value === ''
      },
      fontStyle () {
        return {fontSize: this.fontScale + "%"}
      }
    },
    created () {
      this.reload()
    },
    mounted () {
      this.$refs.input.addEventListener('paste', function (e) {
        e.preventDefault()
        var text = e.clipboardData.getData('text/plain')
        document.execCommand('insertText', false, text)
      })
    }
  }
</script>
<style lang='scss' scoped>
  .content-editable {
    position: relative;
    min-width: 30px;
  }
  .tag {
    .content-editable--input {
      border-bottom: 1px dashed #ccc;
    }
  }
  .content-editable--input {
    z-index: 2;
    position: relative;
    &:focus {
      outline: none;
    }
  }
  h1, h2, h3, h4 {
    margin-bottom: 0.75rem;
  }
  div.content-editable--input {
    margin-bottom: 1rem;
  }
  .placeholder {
    position: absolute;
    top:0;
    left:0;
    transform: translate(4px, 20%);
    color: #aaa;
    z-index: 1
  }
</style>